module.exports = __webpack_public_path__ + "media/images/lb/397-6b4024a77f20f1d48ba57dd6e5a0c11e.svg";